import { projectFinancialsResx } from "~/resxDist/projectFinancialsResx";
import { taskDetailsResx } from "~/resxDist/taskDetailsResx";

export const taskBillingType = {
    NotBillable: 1,
    HourlyRate: 2,
    FixedCost: 3,
    ProjectBillingSettings: 4,
    RateCard: 5,
};

export const projectBillingType = {
    ResourceHourlyRate: 1,
    CustomerHourlyRate: 2,
    TaskRate: 3,
    ProjectHourlyRate: 4,
    ProjectFixedCost: 5,
    NotBillable: 6,
    RateCard: 7,
};

export const getTaskBillingTypeText = (value: number) => {
    switch (value) {
        case taskBillingType.FixedCost:
            return projectFinancialsResx.FlatFee;
        case taskBillingType.HourlyRate:
            return projectFinancialsResx.HourlyRate;
        case taskBillingType.NotBillable:
            return projectFinancialsResx.NotBillable;
        case taskBillingType.ProjectBillingSettings:
            return taskDetailsResx.BillingTypeProjectBillingSettings;
        case taskBillingType.RateCard:
            return projectFinancialsResx.RateCardLabel;
        default:
            return "";
    }
};

export const getProjectBillingTypeText = (value: number) => {
    switch (value) {
        case projectBillingType.ResourceHourlyRate:
            return projectFinancialsResx.ResourceHourlyRateLabel;
        case projectBillingType.CustomerHourlyRate:
            return projectFinancialsResx.CustomerHourlyRateLabel;
        case projectBillingType.NotBillable:
            return projectFinancialsResx.NotBillable;
        case projectBillingType.TaskRate:
            return projectFinancialsResx.TaskRateLabel;
        case projectBillingType.ProjectHourlyRate:
            return projectFinancialsResx.ProjectHourlyRateLabel;
        case projectBillingType.ProjectFixedCost:
            return projectFinancialsResx.FlatFee;
        case projectBillingType.RateCard:
            return projectFinancialsResx.RateCardLabel;
        default:
            return "";
    }
};
